import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#ff5a00',
  width = '100%',
  className = '',
  viewBox = '0 0 20.5 20.5',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="search-dollar"
      d="M9.413,7.985l-1.8-.541a.523.523,0,0,1-.351-.51.5.5,0,0,1,.472-.528H8.858a.959.959,0,0,1,.513.149.329.329,0,0,0,.406-.029l.47-.449a.321.321,0,0,0-.023-.486,2.293,2.293,0,0,0-1.256-.454V4.484a.32.32,0,0,0-.32-.32H8.007a.32.32,0,0,0-.32.32V5.13a1.783,1.783,0,0,0-1.708,1.8A1.812,1.812,0,0,0,7.243,8.672l1.8.541a.523.523,0,0,1,.351.51.5.5,0,0,1-.472.528H7.8a.959.959,0,0,1-.513-.149.329.329,0,0,0-.406.029l-.47.449a.321.321,0,0,0,.023.486,2.293,2.293,0,0,0,1.256.454v.652a.32.32,0,0,0,.32.32h.641a.32.32,0,0,0,.32-.32v-.645a1.783,1.783,0,0,0,1.708-1.8A1.812,1.812,0,0,0,9.413,7.985Zm10.946,11.3-5.165-5.165a.475.475,0,0,0-.34-.14h-.412a8.244,8.244,0,1,0-.464.468v.408a.492.492,0,0,0,.14.34l5.165,5.165a.481.481,0,0,0,.681,0l.4-.4a.48.48,0,0,0,0-.68ZM8.328,15.374a7.046,7.046,0,1,1,7.046-7.046A7.041,7.041,0,0,1,8.328,15.374Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
